import { API_BASE_URL } from "./constants";
import { getUserIdentityHeaders } from "./officeContext";
export async function postJson(path, body) {
    const response = await fetch(`${API_BASE_URL}${path}`, {
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            ...getUserIdentityHeaders()
        },
        method: "POST"
    });
    return parseJsonResponse(response);
}
export async function getJson(path) {
    const response = await fetch(`${API_BASE_URL}${path}`, {
        headers: getUserIdentityHeaders()
    });
    return parseJsonResponse(response);
}
export async function deleteJson(path) {
    const response = await fetch(`${API_BASE_URL}${path}`, {
        headers: getUserIdentityHeaders(),
        method: "DELETE"
    });
    return parseJsonResponse(response);
}
async function parseJsonResponse(response) {
    const payload = (await response.json());
    if (!response.ok) {
        let errorMessage = typeof payload === "object" && payload && "error" in payload && payload.error
            ? payload.error
            : `Request failed with status ${response.status}`;
        if (typeof payload === "object" && payload && "issues" in payload && payload.issues?.length) {
            errorMessage = `${errorMessage}: ${payload.issues
                .map((issue) => `${issue.path.join(".") || "request"} ${issue.message}`)
                .join("; ")}`;
        }
        throw new Error(errorMessage);
    }
    return payload;
}
